import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

export const AccessEnabledRenderer = (props) => {
  return (
    <Input
      className="checkbox-grid-input"
      type="checkbox"
      value={props.value}
      checked={props.value}
      disabled={props.data.disabled}
      onChange={props.data.onClick}
    />
  );
};

AccessEnabledRenderer.propTypes = {
  value: PropTypes.bool.isRequired,
  data: PropTypes.object,
};

export default AccessEnabledRenderer;
